import styled from '@emotion/styled';
import { Chip } from 'cprime-foundational-components';

export const StyledChip = styled(Chip)`
  margin-left: auto;
  margin-right: 1rem;
`;
